import { MoonTabs, type MoonTabOption } from "@louise/moon-ui";

export type FunnelScopeTabOption<Id extends string = string> =
  MoonTabOption<Id>;

/** Shared connected scope tabs used by Future Use and CryoVault potential. */
export function FunnelScopeTabs<Id extends string>({
  options,
  active,
  onChange,
}: {
  options: FunnelScopeTabOption<Id>[];
  active: Id;
  onChange: (id: Id) => void;
}) {
  return <MoonTabs options={options} active={active} onChange={onChange} />;
}
